var _circle, _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGraphStat = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    stroke: "#70BB63",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_121_117",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 6.44074 15.5443 4.91547 14.689 3.61173C13.8337 2.30799 12.6161 1.28262 11.1858 0.661687L8 8H16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 6.44074 15.5443 4.91547 14.689 3.61173C13.8337 2.30799 12.6161 1.28262 11.1858 0.661687L8 8H16Z",
    stroke: "#BEC9DA",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1_121_117)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGraphStat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/graph-stat.964c81a3.svg";
export { ForwardRef as ReactComponent };